import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Leaf } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-[#E6E2D8] bg-[#F3F0EA] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-4">
            <Leaf className="w-5 h-5 text-[#8A9A86]" strokeWidth={1.5} />
            <span className="font-serif text-2xl">Valeria Cantore</span>
          </Link>
          <p className="text-[#5C6356] max-w-md leading-relaxed">{t("footer.description")}</p>
          <div className="flex items-center gap-3 mt-6 text-sm text-[#5C6356]">
            <MapPin size={14} className="text-[#8A9A86]" strokeWidth={1.5} />
            <a href="https://maps.app.goo.gl/Wzhg9jPpaPa8TEPb7" target="_blank" rel="noreferrer" className="hover:text-[#2C2F2A]">
              Corso Italia, 259 — 74121 Taranto (TA)
            </a>
          </div>
          <a
            href="https://www.instagram.com/lanaturacomecura"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 mt-5 px-4 py-2 rounded-full border border-[#E6E2D8] hover:bg-[#8A9A86] hover:text-white hover:border-[#8A9A86] transition-colors text-sm"
          >
            <Instagram size={15} strokeWidth={1.5} /> @lanaturacomecura
          </a>
        </div>

        <div>
          <div className="label-eyebrow mb-4">{t("footer.navigate")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/chi-sono" className="hover:text-[#8A9A86] transition-colors">{t("nav.about")}</Link></li>
            <li><Link to="/servizi" className="hover:text-[#8A9A86] transition-colors">{t("nav.services")}</Link></li>
            <li><Link to="/prenotazioni" className="hover:text-[#8A9A86] transition-colors">{t("nav.book")}</Link></li>
            <li><Link to="/blog" className="hover:text-[#8A9A86] transition-colors">{t("nav.blog")}</Link></li>
            <li><Link to="/testimonianze" className="hover:text-[#8A9A86] transition-colors">{t("nav.testimonials")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-eyebrow mb-4">{t("footer.contact")}</div>
          <ul className="space-y-3 text-sm text-[#5C6356]">
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 text-[#8A9A86]" strokeWidth={1.5} />
              <a href="mailto:valeriacantnaturopatia@gmail.com" className="hover:text-[#2C2F2A] break-all">
                valeriacantnaturopatia@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-1 text-[#8A9A86]" strokeWidth={1.5} />
              <a href="tel:+393482478661" className="hover:text-[#2C2F2A]">+39 348 247 8661</a>
            </li>
            <li className="text-xs mt-3">{t("footer.hours")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E6E2D8] py-6 text-center text-xs text-[#5C6356]">
        © {new Date().getFullYear()} Studio di Massoterapia · Valeria Cantore — {t("footer.rights")}
      </div>
    </footer>
  );
}
